export { TutorPlatformFeedbackCard } from "./TutorPlatformFeedbackCard"
export type { TutorPlatformFeedbackCardProps } from "./TutorPlatformFeedbackCard"
